import React, { useState } from 'react';
import { ShieldCheckIcon, ZapIcon, LockIcon, ClockIcon } from 'lucide-react';
import { UpgradeModal } from './UpgradeModal';
type PlanType = 'esencial' | 'pro' | 'academia';
export function PricingSection() {
  const [selectedPlan, setSelectedPlan] = useState<PlanType>('pro');
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [showProUpgradeModal, setShowProUpgradeModal] = useState(false);
  const [showAcademiaUpgradeModal, setShowAcademiaUpgradeModal] = useState(false);
  const plans = {
    esencial: {
      name: 'PLAN ESENCIAL',
      icon: '📘',
      description: 'Tomos 1-4 + Pack Premium Diseño',
      price: '$19.990',
      oldPrice: '$39.990',
      url: 'https://checkout.empezahoy.shop/cart/48089967624424:1',
      buttonText: 'Sí, quiero este plan'
    },
    pro: {
      name: 'SISTEMA PRO',
      icon: '🏆',
      description: 'Todos los Tomos + Todos los Bonos',
      price: '$24.990',
      oldPrice: '$59.990',
      url: 'https://checkout.empezahoy.shop/cart/48160854671592:1',
      buttonText: 'Sí, Quiero el Sistema Completo',
      badge: 'MÁS ELEGIDO',
      savings: 'AHORRÁS $34.990'
    },
    academia: {
      name: 'PLAN ACADEMIA TOTAL',
      icon: '🟣',
      description: 'Sistema PRO + Tarot Master Curriculum',
      price: '$39.990',
      oldPrice: '$117.990',
      url: 'https://checkout.empezahoy.shop/cart/48160855163112:1',
      buttonText: 'Sí, quiero Academia Total'
    }
  };
  const currentPlan = plans[selectedPlan];
  return <section id="comprar" className="relative z-10 py-10 md:py-14 px-4 bg-gradient-to-b from-[#1a1030] to-[#0f0a1e]" data-id="element-128">
      <div className="max-w-2xl mx-auto" data-id="element-129">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-130">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-2" data-id="element-131">
            Elegí tu pack
          </h2>
          <p className="text-lg text-white/70" data-id="element-132">
            Acceso inmediato a todos los recursos
          </p>
        </div>

        {/* Pricing Options */}
        <div className="space-y-4 mb-6" data-id="element-133">
          {/* Plan Esencial */}
          <button onClick={() => setSelectedPlan('esencial')} className={`w-full text-left p-4 rounded-2xl border-2 transition-all ${selectedPlan === 'esencial' ? 'border-[#F5C842] bg-[#1a1030]' : 'border-white/10 bg-[#0f0a1e] hover:border-white/20'}`} data-id="element-134">
            <div className="flex items-center gap-4" data-id="element-135">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedPlan === 'esencial' ? 'border-[#F5C842] bg-[#F5C842]' : 'border-white/30'}`} data-id="element-136">
                {selectedPlan === 'esencial' && <div className="w-3 h-3 rounded-full bg-[#0f0a1e]" data-id="element-137"></div>}
              </div>
              <div className="flex-1" data-id="element-138">
                <div className="flex items-center gap-2 mb-1" data-id="element-139">
                  <span className="text-xl" data-id="element-140">📘</span>
                  <h3 className="text-white font-bold text-base" data-id="element-141">
                    PLAN ESENCIAL
                  </h3>
                </div>
                <p className="text-white/60 text-sm" data-id="element-142">
                  Tomos 1-4 + Pack Premium Diseño
                </p>
              </div>
              <div className="text-right" data-id="element-143">
                <p className="text-white/40 text-sm line-through" data-id="element-144">$39.990</p>
                <p className="text-white font-black text-2xl" data-id="element-145">$19.990</p>
              </div>
            </div>
          </button>

          {/* Sistema PRO - Destacado */}
          <button onClick={() => setSelectedPlan('pro')} className={`w-full text-left p-4 rounded-2xl border-2 transition-all relative ${selectedPlan === 'pro' ? 'border-[#F5C842] bg-gradient-to-br from-[#F5C842]/10 to-[#1a1030]' : 'border-[#F5C842]/30 bg-[#0f0a1e] hover:border-[#F5C842]/50'}`} data-id="element-146">
            {/* Badges */}
            <div className="absolute -top-3 left-4 flex gap-2" data-id="element-147">
              <span className="bg-[#F5C842] text-black text-xs font-bold px-3 py-1 rounded-full" data-id="element-148">
                MÁS ELEGIDO
              </span>
              <span className="bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-149">
                AHORRÁS $34.990
              </span>
            </div>
            <div className="flex items-center gap-4 mt-2" data-id="element-150">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedPlan === 'pro' ? 'border-[#F5C842] bg-[#F5C842]' : 'border-[#F5C842]/50'}`} data-id="element-151">
                {selectedPlan === 'pro' && <div className="w-3 h-3 rounded-full bg-[#0f0a1e]" data-id="element-152"></div>}
              </div>
              <div className="flex-1" data-id="element-153">
                <div className="flex items-center gap-2 mb-1" data-id="element-154">
                  <span className="text-xl" data-id="element-155">🏆</span>
                  <h3 className="text-white font-bold text-base" data-id="element-156">
                    SISTEMA PRO
                  </h3>
                </div>
                <p className="text-white/80 text-sm" data-id="element-157">
                  Todos los Tomos + Todos los Bonos
                </p>
              </div>
              <div className="text-right" data-id="element-158">
                <p className="text-white/40 text-sm line-through" data-id="element-159">$59.990</p>
                <p className="text-[#F5C842] font-black text-2xl" data-id="element-160">$24.990</p>
              </div>
            </div>
          </button>

          {/* Plan Academia Total */}
          <button onClick={() => setSelectedPlan('academia')} className={`w-full text-left p-4 rounded-2xl border-2 transition-all ${selectedPlan === 'academia' ? 'border-purple-500 bg-[#1a1030]' : 'border-white/10 bg-[#0f0a1e] hover:border-white/20'}`} data-id="element-161">
            <div className="flex items-center gap-4" data-id="element-162">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedPlan === 'academia' ? 'border-purple-500 bg-purple-500' : 'border-white/30'}`} data-id="element-163">
                {selectedPlan === 'academia' && <div className="w-3 h-3 rounded-full bg-[#0f0a1e]" data-id="element-164"></div>}
              </div>
              <div className="flex-1" data-id="element-165">
                <div className="flex items-center gap-2 mb-1" data-id="element-166">
                  <span className="text-xl" data-id="element-167">🟣</span>
                  <h3 className="text-white font-bold text-base" data-id="element-168">
                    PLAN ACADEMIA TOTAL
                  </h3>
                </div>
                <p className="text-white/60 text-sm" data-id="element-169">
                  Sistema PRO + Tarot Master Curriculum
                </p>
              </div>
              <div className="text-right" data-id="element-170">
                <p className="text-white/40 text-sm line-through" data-id="element-171">$117.990</p>
                <p className="text-white font-black text-2xl" data-id="element-172">$39.990</p>
              </div>
            </div>
          </button>
        </div>

        {/* CTA Button */}
        <button onClick={() => {
        if (selectedPlan === 'esencial') {
          setShowUpgradeModal(true);
        } else if (selectedPlan === 'pro') {
          setShowProUpgradeModal(true);
        } else if (selectedPlan === 'academia') {
          setShowAcademiaUpgradeModal(true);
        } else {
          window.location.href = currentPlan.url;
        }
      }} className="block w-full text-center bg-gradient-to-r from-[#F5C842] to-[#D4AF37] hover:from-[#D4AF37] hover:to-[#F5C842] text-black font-black py-4 rounded-2xl transition-all duration-300 transform hover:scale-[1.02] shadow-lg shadow-[#F5C842]/20 text-lg mb-4" data-id="element-173">
          {currentPlan.buttonText} →
        </button>

        {/* Plan Details - Dynamic based on selection */}
        <div className="bg-[#0f0a1e] border border-white/10 rounded-xl p-4 mb-3" data-id="element-174">
          {selectedPlan === 'esencial' && <div className="space-y-2" data-id="element-175">
              <p className="text-white font-bold text-sm mb-2" data-id="element-176">
                ✦ Incluye en Plan Esencial:
              </p>
              <div className="space-y-1.5 text-white/70 text-xs" data-id="element-177">
                <p data-id="element-178">📕 Tomo 1: Bienvenida & Perfil (55 pág.)</p>
                <p data-id="element-179">📗 Tomo 2: Planetas en Signos y Casas (60 pág.)</p>
                <p data-id="element-180">📘 Tomo 3: Las 12 Casas Astrológicas (55 pág.)</p>
                <p data-id="element-181">📙 Tomo 4: Aspectos & Configuraciones (60 pág.)</p>
                <p data-id="element-182">🎁 Bono 1: Pack Premium de Diseño</p>
              </div>
            </div>}
          {selectedPlan === 'pro' && <div className="space-y-2" data-id="element-183">
              <p className="text-white font-bold text-sm mb-2" data-id="element-184">
                ✦ Incluye en Sistema PRO:
              </p>
              <div className="grid grid-cols-2 gap-x-3 gap-y-1.5 text-white/70 text-xs" data-id="element-185">
                <p data-id="element-186">📕 Tomo 1: Bienvenida & Perfil</p>
                <p data-id="element-187">📗 Tomo 2: Planetas</p>
                <p data-id="element-188">📘 Tomo 3: 12 Casas</p>
                <p data-id="element-189">📙 Tomo 4: Aspectos</p>
                <p data-id="element-190">📔 Tomo 5: Síntesis & Alma</p>
                <p data-id="element-191">📒 Tomo 6: Manual Astróloga</p>
                <p data-id="element-192">🎁 Bono 1: Pack Diseño</p>
                <p data-id="element-193">🎁 Bono 2: 25 Interpretaciones</p>
                <p className="col-span-2" data-id="element-194">
                  🎁 Bono 3: Kit Ingresos Recurrentes
                </p>
              </div>
            </div>}
          {selectedPlan === 'academia' && <div className="space-y-2" data-id="element-195">
              <p className="text-white font-bold text-sm mb-2" data-id="element-196">
                ✦ Incluye en Academia Total:
              </p>
              <div className="space-y-1.5 text-white/70 text-xs" data-id="element-197">
                <p className="text-[#F5C842]" data-id="element-198">
                  ✓ Todo el Sistema PRO (6 tomos + 3 bonos)
                </p>
                <p className="text-purple-400 font-semibold" data-id="element-199">
                  + EXCLUSIVO ACADEMIA:
                </p>
                <p data-id="element-200">📚 Tarot Master Curriculum (200+ pág.)</p>
                <p data-id="element-201">🏆 Licencia de Re-uso Pedagógico</p>
                <p data-id="element-202">📈 Estructura de Clases completa</p>
                <p className="text-white/90 text-xs mt-2 italic" data-id="element-203">
                  Lanza tu propio curso de Tarot y genera ingresos enseñando
                </p>
              </div>
            </div>}
        </div>

        <p className="text-white/50 text-sm text-center italic mb-8" data-id="element-204">
          La opción más elegida por astrólogas profesionales
        </p>

        {/* Trust Badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 p-4 bg-[#0f0a1e] border border-white/10 rounded-xl" data-id="element-205">
          <div className="flex items-center gap-2 text-white/70" data-id="element-206">
            <LockIcon className="w-4 h-4 text-green-400" data-id="element-207" />
            <span className="text-xs" data-id="element-208">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2 text-white/70" data-id="element-209">
            <ZapIcon className="w-4 h-4 text-[#F5C842]" data-id="element-210" />
            <span className="text-xs" data-id="element-211">Acceso en 5 min</span>
          </div>
          <div className="flex items-center gap-2 text-white/70" data-id="element-212">
            <ShieldCheckIcon className="w-4 h-4 text-green-400" data-id="element-213" />
            <span className="text-xs" data-id="element-214">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-2 text-white/70" data-id="element-215">
            <ClockIcon className="w-4 h-4 text-blue-400" data-id="element-216" />
            <span className="text-xs" data-id="element-217">Mercado Pago</span>
          </div>
        </div>
      </div>
      <UpgradeModal isOpen={showUpgradeModal} onClose={() => setShowUpgradeModal(false)} planType="esencial" data-id="element-218" />
      <UpgradeModal isOpen={showProUpgradeModal} onClose={() => setShowProUpgradeModal(false)} planType="pro" data-id="element-219" />
      <UpgradeModal isOpen={showAcademiaUpgradeModal} onClose={() => setShowAcademiaUpgradeModal(false)} planType="academia" data-id="element-220" />
    </section>;
}